module.exports = __webpack_public_path__ + "static/media/icon_Survey_W.8b390ef9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_Survey_W.svg
// module id = 1939
// module chunks = 0